import React, { useState } from "react";
import { MapPin, Navigation, ArrowUpRight } from "lucide-react";

const VENUE = "Mauttorpromenade 7, 5400 Hallein";
const PARKING = "Mauttorpromenade 12, 5400 Hallein";
const views = {
  venue: { label: "Eventlocation", src: `https://www.google.com/maps?q=${encodeURIComponent(VENUE)}&z=16&output=embed` },
  parking: { label: "Parkplatz → Eingang", src: `https://www.google.com/maps?saddr=${encodeURIComponent(PARKING)}&daddr=${encodeURIComponent(VENUE)}&dirflg=w&z=17&output=embed` },
};
const dir = (mode) =>
  "https://www.google.com/maps/dir/?api=1&destination=" + encodeURIComponent(VENUE) + `&travelmode=${mode}`;

const routes = [
  { mode: "driving", label: "Auto" },
  { mode: "transit", label: "Öffis" },
  { mode: "walking", label: "Zu Fuß" },
];

export default function EventMap() {
  const [loaded, setLoaded] = useState(false);
  const [view, setView] = useState("venue");

  return (
    <div data-testid="eventinfo-map" className="overflow-hidden rounded-2xl border border-white/10 bg-black/25">
      {loaded && (
        <div className="flex gap-1 border-b border-white/10 p-2" data-testid="eventinfo-map-tabs">
          {Object.entries(views).map(([k, v]) => (
            <button key={k} onClick={() => setView(k)} data-testid={`eventinfo-map-tab-${k}`}
              className={`mono-label rounded-full px-4 py-2 text-[10px] transition-colors ${view === k ? "bg-[var(--crtr-yellow)] text-black" : "text-white/60 hover:text-white"}`}>
              {v.label}
            </button>
          ))}
        </div>
      )}
      <div className="relative aspect-[4/3] sm:aspect-[16/9]">
        {loaded ? (
          <iframe
            key={view}
            title={`Google Maps – ${views[view].label}`}
            src={views[view].src}
            className="absolute inset-0 h-full w-full border-0"
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            data-testid="eventinfo-map-iframe"
          />
        ) : (
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 px-6 text-center" style={{ backgroundImage: "radial-gradient(rgba(255,255,255,0.08) 1px, transparent 1px)", backgroundSize: "22px 22px" }}>
            <MapPin className="h-8 w-8 text-[var(--crtr-yellow)]" strokeWidth={1.5} />
            <p className="font-heavy text-lg text-white">Schmiede Hallein · Mauttorpromenade 7</p>
            <p className="max-w-sm text-xs leading-relaxed text-white/50">Beim Laden der Karte werden Daten an Google übertragen. Es gelten die Datenschutzbestimmungen von Google.</p>
            <button onClick={() => setLoaded(true)} data-testid="eventinfo-map-load"
              className="mono-label mt-1 rounded-full bg-[var(--crtr-yellow)] px-6 py-2.5 text-xs text-black transition-transform hover:scale-[1.03]">
              Google Maps laden
            </button>
          </div>
        )}
      </div>
      <div className="flex flex-col gap-3 border-t border-white/10 px-4 py-4 sm:flex-row sm:items-center sm:justify-between">
        <span className="mono-label inline-flex items-center gap-2 text-[10px] text-white/50">
          <Navigation className="h-3.5 w-3.5 text-[var(--crtr-yellow)]" /> Route berechnen
        </span>
        <div className="flex flex-wrap gap-2">
          {routes.map((r) => (
            <a key={r.mode} href={dir(r.mode)} target="_blank" rel="noreferrer" data-testid={`eventinfo-route-${r.mode}`}
              className="group inline-flex items-center gap-1.5 rounded-full border border-[var(--crtr-yellow)]/60 px-4 py-2 text-xs font-medium text-[var(--crtr-yellow)] transition-colors hover:bg-[var(--crtr-yellow)] hover:text-black">
              {r.label}
              <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
